import { takeEvery } from "@redux-saga/core/effects";
import { MarkersActionTypes } from "./../types";
import { addMarkerSaga } from "./addMarker";
import { deleteMarkerSaga } from "./deleteMarker";
import { initalMarkerSaga } from "./initalMarker";
import { updateMarkerSaga } from "./updateMarker";

export default function* MarkersSaga() {
    yield takeEvery(MarkersActionTypes.INITAL_MARKER, initalMarkerSaga);
    yield takeEvery(MarkersActionTypes.ADD_MARKER_REQUEST, addMarkerSaga);
    yield takeEvery(MarkersActionTypes.DELETE_MARKER_REQUEST, deleteMarkerSaga);
    yield takeEvery(MarkersActionTypes.UPDATE_MARKER_REQUEST, updateMarkerSaga);
}
